























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { SalesRegionsStringType } from "@/models/map/region_type";
import { UserGetters } from "@/store/modules/user/types";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { StoreModule } from "@/store/types";
import { namespace } from "vuex-class";
import { Roles } from "@/models/roles";
import { RepGetters } from "@/store/modules/rep/types";
import { Layers } from "@/models/map/layers";
import { EventBus } from "@/events";

@Component
export default class Sidebar extends Vue {
  @Prop() region?: SalesRegionsStringType;
  protected Roles = Roles;
  protected Layers = Layers;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.User).Getter(UserGetters.GetUser)) user;
  @(namespace(StoreModule.User).Getter(UserGetters.GetSalesRegion))
  assignedRegion;
  @(namespace(StoreModule.Rep).Getter(RepGetters.GetSelected))
  selected;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetActiveView))
  activeView;
    @(namespace(StoreModule.Global).Action(GlobalActions.AddLoading)) setLoading;

  public goBack(): void {
    this.$router.go(-1);
    setTimeout(() => this.setLoading(false), 200)
  }

  get tabLabel(): string {
    let label;
    if (this.activeView === Layers.Contract) {
      label = "Contract Customers";
    } else if (this.activeView === Layers.Beach) {
      label = "Beach Concession Customers";
    } else {
      label = "Customers";
    }
    return label;
  }

  
public formatSalesRegion = (str: string): SalesRegionsStringType => {
  if (str.includes('-')) {
        return str.split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('-') as SalesRegionsStringType;
  } else {
        return str.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ') as SalesRegionsStringType;
  }
}
}
